import maplibregl from "maplibre-gl";
import norkartStyleSpecification from "./mapStyleSpecification.ts";
import { loadDataSourceFromState } from "./sources/loadDataSourceFromState.ts";
import { loadMarkerFromState } from "./marker/loadMarkerFromState.ts";
import { AppState } from "./AppState.ts";
import { i18n } from "@lingui/core";

const initializeMap = (container: HTMLElement): void => {
	const state = new AppState();

	const map = new maplibregl.Map({
		container: container,
		style: norkartStyleSpecification,
		center: state.center,
		zoom: state.zoomLevel,
		pitchWithRotate: false,
		dragRotate: false,
		attributionControl: false,
		locale: {
			"NavigationControl.ZoomIn": i18n.t({
				id: "mapControl.zoomIn",
				comment: "Title for the zoom in button in the corner of the map",
			}),
			"NavigationControl.ZoomOut": i18n.t({
				id: "mapControl.zoomOut",
				comment: "Title for the zoom out button in the corner of the map",
			}),
		},
	});

	map.addControl(
		new maplibregl.NavigationControl({
			showZoom: true,
			visualizePitch: true,
			showCompass: false,
		}),
		"bottom-right",
	);

	map.on("load", () => {
		loadDataSourceFromState(map);
		loadMarkerFromState(map);
	});

	map.on("move", () => {
		const lng = map.getCenter().lng;
		const lat = map.getCenter().lat;

		state.center = [lng, lat];
	});

	map.on("zoom", () => {
		state.zoomLevel = map.getZoom();
	});
};

const getMapContainer = (): HTMLElement | null => {
	const container = document.querySelector("map-preview-podlet-isolated")?.shadowRoot?.querySelector("#maplibre");
	container?.setAttribute("style", "height: 100%; width: 100%;");
	return container instanceof HTMLElement ? container : null;
};

const container = getMapContainer();

if (container) {
	initializeMap(container);
} else {
	console.error("Map container not found in shadow DOM.");
}
